import { render, staticRenderFns } from "./business_form.vue?vue&type=template&id=bbc42518&scoped=true&"
import script from "./business_form.vue?vue&type=script&lang=js&"
export * from "./business_form.vue?vue&type=script&lang=js&"
import style0 from "./business_form.vue?vue&type=style&index=0&id=bbc42518&prod&lang=css&"
import style1 from "./business_form.css?vue&type=style&index=1&id=bbc42518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc42518",
  null
  
)

export default component.exports